import React from "react";
// import { Player } from "video-react";
import { ContainerMorePortfolio } from "./StyledComponents/ShowMore.style";

import Yoship from "./asset/video/Yoship.mp4";
import SorryImLate from "./asset/video/SorryImLate.mp4";
import Slack_Clone from "./asset/video/Slack_Clone.mp4";

import "./styleMobile.css";

const MorePortfolioMobile = () => {
  return (
    <>
      <ContainerMorePortfolio>
        <div className="videoPortfolioMobile">
          <div className="containerPortfolioMobile">
            <div className="containerPortfolioVideoMobile">
              <h3>Sorry I'm Late</h3>
              <p>
                J'ai utilisé React et Node pour le server. Pour recevoir les
                données en temps réel, j'ai utilisé différentes API (Twitter,
                météo...).
              </p>
              <video preload="auto" controls>
                <source src={SorryImLate} type="video/mp4" />
              </video>
            </div>
            <div className="containerPortfolioVideoMobile">
              <h3>Yoship</h3>
              <p>
                J'ai utilisé React, Node et express pour le server et MySQL pour
                la base de données.
              </p>
              <video preload="auto" controls>
                <source src={Yoship} type="video/mp4" />
              </video>
            </div>
            <div className="containerPortfolioVideoMobile">
              <h3>Slack_Clone</h3>
              <p>
                J'ai utilisé React, Mango DB, et Node pour le server. Comme vous
                pouvez le voir dans la vidéo, j'ai utilisé les webSocket.
              </p>
              <video preload="auto" controls>
                <source src={Slack_Clone} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </ContainerMorePortfolio>
    </>
  );
};

export default MorePortfolioMobile;
